import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const FAQS = [
  { q: 'How do I create an account?', a: "Click 'Join Free' on the homepage or 'Register' on the login page. Fill in your name, email, and password. Your account is ready instantly!" },
  { q: 'How do I claim an offer?', a: "Browse our Offers page, find an offer you like, and click 'Claim Now'. You'll be prompted to log in. Once logged in, our support team will assist you with the claim." },
  { q: 'How do I start playing a game?', a: "Go to the Games page, find a game marked as Live, and click 'Play Now'. You'll need to log in to access the game. Our support team can help you get started." },
  { q: 'How do I contact support?', a: 'Log into your account and use the Support Chat. Our team is available 24/7 and typically responds within seconds.' },
  { q: 'Is my data safe with MegaFishHub?', a: 'Yes. We use 256-bit SSL encryption for all data. Your password is hashed and never stored in plain text. We never sell or share your personal data.' },
  { q: 'How do I become a VIP member?', a: 'VIP status is granted by our admin team based on activity and engagement. Contact our support team in the chat to learn more about VIP benefits.' },
  { q: 'Can I delete my account?', a: "Yes, contact our support team via the live chat and we'll process your deletion request within 24 hours." },
];

export default function SupportPage() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div style={{ minHeight: '100vh', background: '#080c14', fontFamily: "'Exo 2',sans-serif", color: '#e2e8f0', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@600;700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        .sp-bg{position:fixed;inset:0;background-image:linear-gradient(rgba(245,166,35,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(245,166,35,.025) 1px,transparent 1px);background-size:50px 50px;pointer-events:none;z-index:0}
        .sp-nav{position:sticky;top:0;background:rgba(8,12,20,.96);backdrop-filter:blur(12px);border-bottom:1px solid rgba(245,166,35,.08);z-index:100}
        .sp-nav-inner{max-width:1200px;margin:0 auto;padding:0 20px;height:62px;display:flex;align-items:center;gap:20px}
        .sp-logo{display:flex;align-items:center;gap:7px;text-decoration:none;flex-shrink:0}
        .sp-logo-text{font-family:'Rajdhani',sans-serif;font-size:19px;font-weight:700;color:#f5a623;letter-spacing:5px}
        .sp-nav-links{display:flex;gap:20px;flex:1}
        .sp-nav-link{color:rgba(255,255,255,.45);text-decoration:none;font-size:13px;font-weight:600;letter-spacing:1px}
        .sp-nav-link:hover{color:#f5a623}
        .sp-login-btn{background:#f5a623;color:#080c14;padding:7px 15px;border-radius:8px;text-decoration:none;font-size:12px;font-weight:900;letter-spacing:1px;flex-shrink:0}
        .sp-hamburger{display:none;background:none;border:1px solid rgba(245,166,35,.25);color:#f5a623;font-size:17px;cursor:pointer;padding:5px 9px;border-radius:7px;margin-left:auto}
        .sp-mobile-menu{display:none;position:fixed;top:62px;left:0;right:0;background:rgba(8,12,20,.98);backdrop-filter:blur(12px);border-bottom:1px solid rgba(245,166,35,.1);padding:14px 20px;flex-direction:column;gap:4px;z-index:99}
        .sp-mobile-menu.open{display:flex}
        .sp-mobile-link{color:rgba(255,255,255,.6);text-decoration:none;font-size:14px;font-weight:600;padding:11px 0;border-bottom:1px solid rgba(255,255,255,.05);display:block}
        .sp-inner{max-width:1200px;margin:0 auto;padding:40px 20px;position:relative;z-index:1}
        .sp-hero{text-align:center;padding:32px 0 52px}
        .sp-hero-tag{color:rgba(245,166,35,.6);font-size:10px;font-weight:900;letter-spacing:4px;margin-bottom:10px}
        .sp-hero-title{font-family:'Rajdhani',sans-serif;font-size:clamp(34px,6vw,68px);font-weight:700;color:#e2e8f0;margin-bottom:12px}
        .sp-hero-sub{color:rgba(255,255,255,.35);font-size:15px;margin-bottom:28px}
        .sp-hero-btn{background:#f5a623;border:none;border-radius:12px;padding:14px 30px;color:#080c14;font-size:14px;font-weight:900;letter-spacing:2px;cursor:pointer;font-family:'Rajdhani',sans-serif}
        .sp-hero-btn:hover{background:#00d4a0}
        .sp-channels{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:16px;margin-bottom:56px}
        .sp-channel{background:#0d1420;border-radius:18px;border:1px solid rgba(245,166,35,.08);padding:24px;transition:all .25s}
        .sp-channel:hover{border-color:rgba(245,166,35,.25);transform:translateY(-3px)}
        .sp-ch-icon{font-size:32px;margin-bottom:12px}
        .sp-ch-title{font-family:'Rajdhani',sans-serif;font-size:18px;font-weight:700;color:#e2e8f0;margin-bottom:7px}
        .sp-ch-desc{color:rgba(255,255,255,.35);font-size:13px;line-height:1.6;margin-bottom:12px}
        .sp-ch-badge{display:inline-block;background:rgba(245,166,35,.08);border:1px solid rgba(245,166,35,.15);border-radius:7px;padding:3px 9px;font-size:11px;color:rgba(245,166,35,.7);margin-bottom:14px}
        .sp-ch-btn{background:transparent;border:1px solid rgba(245,166,35,.2);border-radius:9px;padding:9px 16px;color:#f5a623;font-size:12px;font-weight:700;cursor:pointer;font-family:'Exo 2',sans-serif}
        .sp-ch-btn:hover{background:rgba(245,166,35,.06)}
        .sp-sec-tag{color:rgba(245,166,35,.6);font-size:10px;font-weight:900;letter-spacing:4px;margin-bottom:8px}
        .sp-sec-title{font-family:'Rajdhani',sans-serif;font-size:clamp(22px,4vw,38px);font-weight:700;color:#e2e8f0;margin-bottom:24px}
        .sp-faq-list{display:flex;flex-direction:column;gap:8px;margin-bottom:52px}
        .sp-faq{background:#0d1420;border-radius:13px;border:1px solid rgba(245,166,35,.08);padding:18px 20px;cursor:pointer;transition:border-color .2s}
        .sp-faq:hover{border-color:rgba(245,166,35,.2)}
        .sp-faq-head{display:flex;justify-content:space-between;align-items:center;gap:14px}
        .sp-faq-q{color:#e2e8f0;font-size:14px;font-weight:600;flex:1;line-height:1.4}
        .sp-faq-toggle{color:#f5a623;font-size:22px;font-weight:300;flex-shrink:0;transition:transform .2s;line-height:1}
        .sp-faq-a{margin-top:12px;color:rgba(255,255,255,.45);font-size:13px;line-height:1.7;border-top:1px solid rgba(245,166,35,.06);padding-top:12px}
        .sp-cta{text-align:center;background:linear-gradient(135deg,rgba(245,166,35,.06),rgba(0,212,255,.03));border:1px solid rgba(245,166,35,.1);border-radius:18px;padding:44px 20px;margin-bottom:36px}
        .sp-cta-title{font-family:'Rajdhani',sans-serif;font-size:clamp(26px,4vw,42px);font-weight:700;color:#e2e8f0;margin-bottom:10px}
        .sp-cta-sub{color:rgba(255,255,255,.35);font-size:14px;margin-bottom:24px}
        .sp-cta-btn{background:#f5a623;border:none;border-radius:12px;padding:13px 28px;color:#080c14;font-size:14px;font-weight:900;letter-spacing:2px;cursor:pointer;font-family:'Rajdhani',sans-serif}
        .sp-footer{border-top:1px solid rgba(245,166,35,.06);padding:22px;text-align:center;position:relative;z-index:1}
        .sp-footer-text{color:rgba(255,255,255,.2);font-size:12px}
        .sp-footer-link{color:rgba(245,166,35,.5);text-decoration:none}
        @media(max-width:768px){
          .sp-nav-links,.sp-login-btn{display:none}
          .sp-hamburger{display:block}
          .sp-channels{grid-template-columns:1fr}
          .sp-inner{padding:32px 16px}
        }
      `}</style>
      <div className="sp-bg" />

      <nav className="sp-nav">
        <div className="sp-nav-inner">
          <Link to="/" className="sp-logo"><img src="/logo.jpg" alt="MegaFishHub" style={{ height: "38px", width: "auto", objectFit: "contain" }} /></Link>
          <div className="sp-nav-links">
            <Link to="/games" className="sp-nav-link">Games</Link>
            <Link to="/offers" className="sp-nav-link">Offers</Link>
            <Link to="/privacy" className="sp-nav-link">Privacy</Link>
          </div>
          <Link to="/login" className="sp-login-btn">→ LOGIN</Link>
          <button className="sp-hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </nav>
      <div className={`sp-mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/" className="sp-mobile-link" onClick={() => setMenuOpen(false)}>🏠 Home</Link>
        <Link to="/games" className="sp-mobile-link" onClick={() => setMenuOpen(false)}>🎮 Games</Link>
        <Link to="/offers" className="sp-mobile-link" onClick={() => setMenuOpen(false)}>🎁 Offers</Link>
        <Link to="/privacy" className="sp-mobile-link" onClick={() => setMenuOpen(false)}>🔒 Privacy</Link>
        <Link to="/login" className="sp-mobile-link" onClick={() => setMenuOpen(false)} style={{ color: '#f5a623' }}>→ Login</Link>
      </div>

      <div className="sp-inner">
        <div className="sp-hero">
          <div className="sp-hero-tag">SUPPORT CENTER</div>
          <h1 className="sp-hero-title">How can we help?</h1>
          <p className="sp-hero-sub">Our team is online 24/7 — we typically reply within seconds.</p>
          <button className="sp-hero-btn" onClick={() => navigate('/login')}>💬 START LIVE CHAT</button>
        </div>

        <div className="sp-channels">
          {[
            { icon: '💬', title: 'Live Chat', desc: 'Instant support from real agents. Available 24/7.', badge: '🟢 Online Now', action: () => navigate('/login'), btn: 'Start Chat' },
            { icon: '📧', title: 'Email Support', desc: 'Send us a detailed message. We reply within 2 hours.', badge: '⏱ 2h avg reply', action: () => navigate('/login'), btn: 'Send Message' },
            { icon: '📖', title: 'Help Center', desc: 'Browse FAQs and guides for instant answers.', badge: '📚 50+ Articles', action: () => {}, btn: 'Browse Below' },
          ].map(ch => (
            <div key={ch.title} className="sp-channel">
              <div className="sp-ch-icon">{ch.icon}</div>
              <h3 className="sp-ch-title">{ch.title}</h3>
              <p className="sp-ch-desc">{ch.desc}</p>
              <div className="sp-ch-badge">{ch.badge}</div>
              <br />
              <button className="sp-ch-btn" onClick={ch.action}>{ch.btn} →</button>
            </div>
          ))}
        </div>

        <div className="sp-sec-tag">FREQUENTLY ASKED</div>
        <h2 className="sp-sec-title">Common Questions</h2>
        <div className="sp-faq-list">
          {FAQS.map((faq, i) => (
            <div key={i} className="sp-faq" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
              <div className="sp-faq-head">
                <span className="sp-faq-q">{faq.q}</span>
                <span className="sp-faq-toggle" style={{ transform: openFaq === i ? 'rotate(45deg)' : 'none' }}>+</span>
              </div>
              {openFaq === i && <div className="sp-faq-a">{faq.a}</div>}
            </div>
          ))}
        </div>

        <div className="sp-cta">
          <h2 className="sp-cta-title">Still need help?</h2>
          <p className="sp-cta-sub">Our live support team is just one click away.</p>
          <button className="sp-cta-btn" onClick={() => navigate('/login')}>💬 CHAT WITH US NOW</button>
        </div>
      </div>

      <footer className="sp-footer">
        <p className="sp-footer-text">© 2025 MegaFishHub · <Link to="/privacy" className="sp-footer-link">Privacy Policy</Link></p>
      </footer>
    </div>
  );
}